<template>
<v-card outlined tile :loading="loading" :disabled="loading">
  <v-card-title>
    Customer Samples
  </v-card-title>
  <v-card-text>

    <v-data-table
        :headers="headers"
        :items="customersWithSamples"
        item-key="id"
        show-expand
        disable-pagination
        hide-default-footer
    >
      <template v-slot:item.customer.primary_name="{item}">
        <div class="">{{item.primary_name.name}}</div>
      </template>
      <template v-slot:item.customer.samples="{item}">
        {{item.samples.filter(samp => !samp.billing_approved).length}}
      </template>
      <template v-slot:item.move_all="{item}">
        <v-btn small outlined color="success" @click="addAll(item.samples)">
          <v-icon>mdi-arrow-right</v-icon>
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{item,headers}">
        <td :colspan="headers.length" class="mr-0 pa-0">
          <v-card outlined tile>
            <v-simple-table dense>
              <tbody>
              <tr v-for="sample in item.samples.filter(samp => !samp.billing_approved)" :key="sample.uuid">
<!--              <tr v-for="sample in item.samples" :key="sample.uuid">-->
                <td style="white-space:nowrap"><v-chip v-if="+sample.weight === 0" color="primary" label x-small>Pending</v-chip> {{ sample.id }}</td>
                <td class="text-right">
                  <v-btn outlined color="error" small icon class="mr-3"><v-icon>close</v-icon></v-btn>
                  <v-btn @click="$emit('add', sample)" outlined color="success" :disabled="isInvoiced(sample.uuid)" small icon><v-icon>mdi-arrow-right</v-icon></v-btn>
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </td>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</template>

<script>
export default {
    name: "CustomersWithBillableSamples",
    components: {},
    props: {
      invoice_samples:{
        required: true,
      }
    },
    data: () => ({
      loading: false,
      headers: [
        {text: "Customer", value: 'customer.primary_name', classes: "subtitle"},
        {text: "Count", value: 'customer.samples', classes: "subtitle"},
        {text: "Bill All", value: 'move_all', classes: "subtitle"},
        { text: '', value: 'data-table-expand' },
      ]
    }),
    computed:{
      customersWithSamples(){
        return this.$store.$db().model('customers').query().whereHas('samples', query => query.where('billing_approved', false)).with(['samples.sample_flags','samples.sample_tests.test_type', 'samples.sample_cert_type.category', 'samples.sample_notes.note_type', 'names']).orderBy((customer) => customer.primary_name.name).all()
        // return this.$store.$db().model('customers').query().with(['samples.sample_flags','samples.sample_tests.test_type', 'samples.sample_cert_type.category', 'samples.sample_notes.note_type', 'names']).orderBy((customer) => customer.primary_name.name).all()
      }
    },
    mounted(){
      this.loadSamples();
    },
    methods: {
      async loadSamples(){
        this.loading = true;
        await this.$store.$db().model('samples').deleteAll();
        await this.$store.$db().model('sampleTests').deleteAll();
        await this.$store.$db().model('samples').api().fetch({
          where: [
            {key: "billing_approved", value: false},
          ],
          not_null: 'order_id',
          with: 'sampleTests,sampleFlags,sampleNotes.noteType',
          // limit: 20
          order_by_desc: 'id'
        });
        this.loading = false;
        this.$emit('loaded');
      },
      async approveBilling(sample){
        await this.$store.$db().model('samples').api().save({
          uuid: sample.uuid,
          id: sample.id,
          billing_approved: true,
        })
      },
      isInvoiced(uuid){
        return !!this.invoice_samples.find(sample => sample.sample_uuid === uuid)
      },
      addAll(items){
        for(let item of items){
          this.$emit('add', item)
        }
      }
    }
}
</script>

<style scoped>

</style>
